import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { useOnlineCount } from "@/lib/presence";

export const OnlineCounter = () => {
    const count = useOnlineCount();
    const [pulse, setPulse] = useState(false);
    const [prev, setPrev] = useState(0);
    useEffect(() => {
        if (count !== prev) {
            setPulse(true);
            setPrev(count);
            const id = setTimeout(() => setPulse(false), 600);
            return () => clearTimeout(id);
        }
    }, [count, prev]);
    return (
        <span
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-mono text-xs uppercase tracking-wider border border-[#22c55e]/40"
            style={{
                background: "#0c1f12",
                color: "#22c55e",
                boxShadow: pulse ? "0 0 16px rgba(34,197,94,0.6)" : "0 0 8px rgba(34,197,94,0.25)",
                transition: "box-shadow 280ms ease",
            }}
            title="Online users (last 60s)"
            data-testid="online-counter"
        >
            <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[#22c55e] opacity-60 animate-ping" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#22c55e]" />
            </span>
            <Users className="w-3.5 h-3.5" />
            <span data-testid="online-counter-value">{count}</span>
            <span className="hidden sm:inline">online</span>
        </span>
    );
};
